/* ====================================================================
   REVITERA — WISSENSSUCHE (22.10.2026)

   Sucht ausschliesslich in den Artikeln der Wissensdatenbank.
   Laeuft vollstaendig im Browser. Keine externen Aufrufe, kein Fremd-Skript.

   KEINE generativen Antworten. Die Suche findet Artikel und zeigt Titel,
   Kategorie und einen Auszug. Sie formuliert nie selbst eine Aussage ueber
   Gesundheit. Das ist eine rechtliche Vorgabe, keine Geschmacksfrage.

   KEINE Produkte. Weder im Index noch in der Ausgabe (Auflage KLTG).

   Aufbau
     1  Normalisierung und Tippfehlertoleranz
     2  Index laden (Section Rendering API, Ablage im sessionStorage)
     3  Bewertung der Treffer
     4  Darstellung
     5  Bedienung (Tastatur, Handy, Screenreader)
     6  Zaehlung ueber den dataLayer
   ==================================================================== */
(function () {
  'use strict';
  if (window.__wissenSucheInit) return;
  window.__wissenSucheInit = true;

  var INDEX_SCHLUESSEL = 'revitera_wissen_index_v1';
  var MINDESTLAENGE = 2;      // ab zwei Zeichen suchen
  var MAX_TREFFER = 24;
  var SENDE_PAUSE = 1500;     // ms Eingabepause, bevor der Begriff gezaehlt wird

  /* ── 1 Normalisierung ──────────────────────────────────────────────
     Beide Seiten, Suchbegriff und Index, laufen durch dieselbe Funktion.
     Deshalb darf sie grosszuegig vereinfachen: entscheidend ist nur, dass
     unterschiedliche Schreibweisen hinterher gleich aussehen.
       Schilddruese   -> schildruse
       Schildrüse     -> schildruse   (fehlendes d faellt mit weg)
       Schilddrüsen   -> schildruse   (ueber die Endungsregel)
       Gamma-GT       -> gamma gt  und zusaetzlich  gammagt
  */
  function normalisiere(s) {
    if (!s) return '';
    return String(s)
      .toLowerCase()
      .replace(/ß/g, 'ss')
      .replace(/ä/g, 'a').replace(/ö/g, 'o').replace(/ü/g, 'u')
      .replace(/é|è|ê/g, 'e').replace(/á|à|â/g, 'a')
      .replace(/ae/g, 'a').replace(/oe/g, 'o').replace(/ue/g, 'u')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/(.)\1+/g, '$1')   // doppelte Buchstaben auf einen
      .replace(/\s+/g, ' ')
      .trim();
  }

  /* Endungen abschneiden, damit Einzahl und Mehrzahl zusammenfallen.
     Erst ab sieben Zeichen, und das aus einem gemessenen Grund: bei der
     Grenze von vier Zeichen wurden "leber" und "leben" beide zu "leb", und
     die Suche nach "leber" lieferte "Leben ohne Schilddruese" als ersten
     Treffer. Ab sieben Zeichen bleiben kurze Grundwoerter unangetastet, die
     Mehrzahlformen, auf die es hier ankommt, sind alle laenger
     ("Schilddruesen", "Leberwerte", "Antikoerper"). */
  function stamm(w) {
    if (w.length <= 6) return w;
    return w.replace(/(ern|en|er|es|em|n|s|e)$/, '');
  }

  function zerlege(s) {
    var n = normalisiere(s);
    if (!n) return [];
    var teile = n.split(' ').filter(Boolean);
    var out = [];
    teile.forEach(function (t) { out.push(t); var st = stamm(t); if (st && st !== t) out.push(st); });
    if (teile.length > 1) { var j = teile.join(''); out.push(j); var sj = stamm(j); if (sj !== j) out.push(sj); }
    return out;
  }

  // Abstand zweier Woerter, abgebrochen sobald die Grenze ueberschritten ist.
  function abstand(a, b, grenze) {
    if (a === b) return 0;
    if (Math.abs(a.length - b.length) > grenze) return grenze + 1;
    var vor = [], jetzt = [], i, j;
    for (j = 0; j <= b.length; j++) vor[j] = j;
    for (i = 1; i <= a.length; i++) {
      jetzt = [i];
      var min = i;
      for (j = 1; j <= b.length; j++) {
        var kosten = a.charCodeAt(i - 1) === b.charCodeAt(j - 1) ? 0 : 1;
        jetzt[j] = Math.min(vor[j] + 1, jetzt[j - 1] + 1, vor[j - 1] + kosten);
        if (jetzt[j] < min) min = jetzt[j];
      }
      if (min > grenze) return grenze + 1;
      vor = jetzt;
    }
    return vor[b.length];
  }

  function toleranz(w) { return w.length >= 8 ? 2 : (w.length >= 5 ? 1 : 0); }

  /* ── Konfiguration aus dem Seitenquelltext ───────────────────────── */
  var konfig = {
    kategorien: [], einstieg: [], synonyme: [], alltag: [], blog_url: '/blogs/wissen',
    wissensseite: true, sonder_titel: '', sonder_begriffe: [], sonder_artikel: []
  };
  try {
    var kel = document.getElementById('WsKonfig');
    if (kel) konfig = Object.assign(konfig, JSON.parse(kel.textContent));
  } catch (e) {}

  // Synonymgruppen: normalisiertes Wort -> Liste aller Woerter der Gruppe
  var synIndex = {};
  (konfig.synonyme || []).forEach(function (zeile) {
    var gruppe = String(zeile).split(',').map(function (x) { return normalisiere(x); }).filter(Boolean);
    if (gruppe.length < 2) return;
    gruppe.forEach(function (w) {
      if (!synIndex[w]) synIndex[w] = [];
      gruppe.forEach(function (x) { if (x !== w && synIndex[w].indexOf(x) < 0) synIndex[w].push(x); });
    });
  });

  // Alltagsbegriffe: normalisiertes Wort -> Kategoriename
  var alltagIndex = {};
  (konfig.alltag || []).forEach(function (zeile) {
    var teile = String(zeile).split('=');
    if (teile.length < 2) return;
    var ziel = teile[1].trim();
    teile[0].split(',').forEach(function (b) {
      var n = normalisiere(b);
      if (n) alltagIndex[n] = ziel;
    });
  });

  var katNachName = {};
  (konfig.kategorien || []).forEach(function (k) { katNachName[normalisiere(k.name)] = k; });

  function katVon(schlagwort) {
    var n = normalisiere(schlagwort);
    for (var i = 0; i < konfig.kategorien.length; i++) {
      if (normalisiere(konfig.kategorien[i].schlagwort) === n || normalisiere(konfig.kategorien[i].name) === n) {
        return konfig.kategorien[i];
      }
    }
    return null;
  }

  function katUrl(k) { return konfig.blog_url + '/tagged/' + k.handle; }
  function artUrl(h) { return konfig.blog_url + '/' + h; }

  /* ── 2 Index laden ─────────────────────────────────────────────────
     Shopify wickelt die Antwort in ein <div>. Wir schaelen es ab und lesen
     den Text. Alle Textwerte sind serverseitig so geschrieben, dass "<" und
     "&" den HTML-Parser nicht stoeren.
  */
  var indexDaten = null, indexLaeuft = null;

  function schaeleJson(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var box = doc.querySelector('[id^="shopify-section-"]') || doc.body;
    return JSON.parse(box.textContent.trim());
  }

  function holeSeite(n) {
    return fetch(konfig.blog_url + '?section_id=wissen-suchindex&page=' + n, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(schaeleJson);
  }

  function ladeIndex() {
    if (indexDaten) return Promise.resolve(indexDaten);
    if (indexLaeuft) return indexLaeuft;

    try {
      var roh = sessionStorage.getItem(INDEX_SCHLUESSEL);
      if (roh) {
        var zw = JSON.parse(roh);
        if (zw && zw.length) { indexDaten = bereiteVor(zw); return Promise.resolve(indexDaten); }
      }
    } catch (e) {}

    indexLaeuft = holeSeite(1).then(function (erste) {
      var seiten = erste.seiten || 1;
      if (seiten <= 1) return [erste];
      var rest = [];
      for (var n = 2; n <= seiten; n++) rest.push(holeSeite(n).catch(function () { return { artikel: [] }; }));
      return Promise.all(rest).then(function (w) { return [erste].concat(w); });
    }).then(function (teile) {
      var alle = [];
      teile.forEach(function (t) { (t.artikel || []).forEach(function (a) { alle.push(a); }); });
      try { sessionStorage.setItem(INDEX_SCHLUESSEL, JSON.stringify(alle)); } catch (e) {}
      indexDaten = bereiteVor(alle);
      return indexDaten;
    }).catch(function (e) {
      indexLaeuft = null;
      throw e;
    });
    return indexLaeuft;
  }

  // Jeden Artikel einmal normalisieren, nicht bei jedem Tastendruck.
  function bereiteVor(rohe) {
    var vok = {};
    var liste = rohe.map(function (a) {
      var tTok = zerlege(a.t);
      var sTok = zerlege(a.s || a.t);
      /* "Gamma-GT" steht im Titel als zwei Woerter, getippt wird oft "gammagt".
         Deshalb benachbarte Wortpaare zusammengezogen mit aufnehmen. */
      var tWorte = normalisiere(a.t).split(' ').filter(Boolean);
      for (var z = 0; z < tWorte.length - 1; z++) {
        var paar = tWorte[z] + tWorte[z + 1];
        if (paar.length <= 24 && tTok.indexOf(paar) < 0) tTok.push(paar);
      }
      tTok.forEach(function (w) { if (w.length > 3) vok[w] = 1; });
      var fragen = [];
      if (a.f) {
        try {
          var fd = JSON.parse(a.f);
          var liste2 = fd && (fd.mainEntity || (fd['@graph'] && fd['@graph'].mainEntity)) || [];
          (Array.isArray(liste2) ? liste2 : [liste2]).forEach(function (q) {
            if (q && q.name) fragen.push({ frage: String(q.name), tok: zerlege(q.name) });
          });
        } catch (e) {}
      }
      return {
        h: a.h, t: a.t, k: a.k, a: a.a, p: a.p === 1,
        tn: normalisiere(a.t), tTok: tTok, sTok: sTok, fragen: fragen
      };
    });
    return { liste: liste, vokabular: Object.keys(vok) };
  }

  /* ── 3 Bewertung ───────────────────────────────────────────────────
     Ein Treffer im Titel zaehlt deutlich mehr als einer im Text. Ein
     Hauptartikel bekommt einen kleinen Zuschlag, damit er oben steht.
  */
  /* Woerter, die wir als Fachbegriff kennen, werden nicht "verbessert".
     Sonst macht die Tippfehlertoleranz aus "Hypothyreose" die
     "Hyperthyreose": zwei Zeichen Unterschied, aber das Gegenteil. Bei
     "hypothyreose symptome" stand deshalb ein Artikel zur Ueberfunktion an
     erster Stelle. Gemessen am 22.10.2026.
     Fuer solche Woerter gelten nur genauer Treffer und Wortanfang. Alles,
     was nicht in den Synonymlisten steht, bleibt tippfehlertolerant. */
  var geschuetzt = {};
  function schuetze(w) {
    if (!w || w.indexOf(' ') >= 0 || w.length < 5) return;
    geschuetzt[w] = true;
    // Auch die Stammform schuetzen, sonst schluepft sie durch: "hypothyreos"
    // steht in keiner Liste und war zu "hyperthyreos" nur zwei Zeichen weit.
    var st = stamm(w);
    if (st && st.length >= 5) geschuetzt[st] = true;
  }
  Object.keys(synIndex).forEach(function (w) {
    schuetze(w);
    (synIndex[w] || []).forEach(schuetze);
  });

  function passt(frageTok, zielTok) {
    // 2 = genau, 1 = Wortanfang oder Tippfehler, 0 = nein
    for (var i = 0; i < zielTok.length; i++) {
      if (zielTok[i] === frageTok) return 2;
    }
    var ohneFuzzy = geschuetzt[frageTok] === true;
    for (var j = 0; j < zielTok.length; j++) {
      var z = zielTok[j];
      if (z.length > frageTok.length && z.indexOf(frageTok) === 0) return 1;
      if (!ohneFuzzy && frageTok.length >= 4
          && abstand(frageTok, z, toleranz(frageTok)) <= toleranz(frageTok)) return 1;
    }
    return 0;
  }

  /* Mehrwortsynonyme wie "nebel im kopf" = "brain fog" greifen nur, wenn die
     ganze Anfrage verglichen wird, nicht Wort fuer Wort. Deshalb wird aus der
     Anfrage eine kleine Liste gleichwertiger Fassungen gemacht. */
  function fassungen(begriff) {
    var n = normalisiere(begriff);
    var liste = [begriff];
    /* Nur Synonyme aus mehreren Woertern loesen eine zweite Bewertung aus.
       Einwortsynonyme sind in gruppen() schon drin, und jede weitere Fassung
       kostet einen vollen Durchlauf ueber alle Artikel. */
    if (n.indexOf(' ') >= 0) {
      (synIndex[n] || []).forEach(function (alt) {
        if (alt.indexOf(' ') >= 0 && liste.indexOf(alt) < 0) liste.push(alt);
      });
    }
    return liste;
  }

  function suche(begriff, daten) {
    var alleFassungen = fassungen(begriff);
    if (alleFassungen.length > 1) {
      var beste = {};
      alleFassungen.forEach(function (f) {
        bewerte(f, daten).forEach(function (t) {
          var vor = beste[t.a.h];
          if (!vor || t.punkte > vor.punkte) beste[t.a.h] = t;
        });
      });
      var zusammen = Object.keys(beste).map(function (k) { return beste[k]; });
      zusammen.sort(function (x, y) { return y.punkte - x.punkte || x.a.t.localeCompare(y.a.t, 'de'); });
      return zusammen.slice(0, MAX_TREFFER);
    }
    return bewerte(begriff, daten);
  }

  function bewerte(begriff, daten) {
    var tok = zerlege(begriff);
    if (!tok.length) return [];

    /* Die eigentlichen Woerter der Anfrage, ohne Stammformen und ohne
       zusammengezogene Fassung. Nur sie entscheiden darueber, ob ein Artikel
       ueberhaupt gemeint sein kann. */
    var worte = normalisiere(begriff).split(' ').filter(Boolean);
    /* Woerter ab fuenf Zeichen muessen vorkommen, sonst ist der Artikel nicht
       gemeint. Ohne diese Regel liefert "thyreogastrisches syndrom" den
       Low-T3-Artikel, nur weil dort "Syndrom" steht.
       Vier Zeichen waren zu streng: bei "gpt wert" fiel der richtige Artikel
       "ALT (GPT) und AST (GOT) erhoeht" heraus, weil das Allerweltswort
       "Wert" dort nicht im Titel und nicht in den indizierten ersten Zeilen
       steht. Gemessen am 22.10.2026. */
    var MINDEST_PFLICHT = 5;

    // Je Wort die Gruppe aus Wort, Stammform und Synonymen.
    var gruppen = worte.map(function (w) {
      var g = [{ w: w, gew: 1 }];
      var st = stamm(w);
      // Etwas unter 1, damit das ganze Wort immer vor seiner Stammform liegt.
      if (st && st !== w) g.push({ w: st, gew: 0.95 });
      (synIndex[w] || []).forEach(function (s) {
        s.split(' ').forEach(function (teil) { if (teil) g.push({ w: teil, gew: 0.75 }); });
      });
      return { wort: w, varianten: g, pflicht: w.length >= MINDEST_PFLICHT };
    });

    var treffer = [];
    daten.liste.forEach(function (a) {
      var punkte = 0, getroffen = 0, offenePflicht = 0, imTitel = 0;

      tok.forEach(function (t) {
        if (a.tn.indexOf(t) >= 0) punkte += 4;      // Teilstring im ganzen Titel
      });

      gruppen.forEach(function (g) {
        var bestes = 0, warImTitel = false;
        /* Das getippte Wort selbst wiegt deutlich mehr als ein Synonym.
           Sonst gewinnt bei "muede" der Wechseljahre-Hauptartikel, weil dort
           "Muedigkeit" im Titel steht, gegen "Staendig muede". */
        g.varianten.forEach(function (e) {
          var eigen = e.gew >= 0.95;
          /* Ein kurzes Synonym darf nicht ueber den Wortanfang treffen.
             Sonst zaehlt das Synonym "ALT" (fuer GPT) als Treffer in
             "Alltag", weil die Normalisierung daraus "altag" macht. Bei
             "gpt wert" stand deshalb "Leben ohne Schilddruese: Hormonersatz,
             Werte und Alltag" vor "ALT (GPT) und AST (GOT) erhoeht".
             Gemessen am 22.10.2026. */
          var nurGenau = !eigen && e.w.length < 4;
          var pT = passt(e.w, a.tTok);
          if (pT && (pT === 2 || !nurGenau)) {
            var w1 = pT === 2 ? (eigen ? 14 : 8) : (eigen ? 6 : 4);
            // Nur das getippte Wort selbst zaehlt fuer "alle Woerter im Titel".
            if (w1 > bestes) { bestes = w1; if (eigen) warImTitel = true; }
            return;
          }
          var pS = passt(e.w, a.sTok);
          if (pS && (pS === 2 || !nurGenau)) {
            var w2 = pS === 2 ? (eigen ? 3 : 2) : (eigen ? 1.5 : 1);
            if (w2 > bestes) bestes = w2;
          }
        });
        if (bestes > 0) {
          punkte += bestes;
          getroffen++;
          if (warImTitel) imTitel++;
        } else if (g.pflicht) {
          offenePflicht++;
        }
      });

      if (offenePflicht > 0) return;

      // Stehen alle Woerter der Anfrage im Titel, ist der Artikel sehr
      // wahrscheinlich gemeint. Ohne diesen Zuschlag gewinnt bei
      // "jod hashimoto" der Hashimoto-Ratgeber gegen "Jod bei Hashimoto".
      if (worte.length > 1 && imTitel === worte.length) punkte += 12;

      // Titel, der mit der Anfrage beginnt, ist meist der gesuchte.
      if (worte[0] && a.tn.indexOf(worte[0]) === 0) punkte += 3;

      /* Hauptartikel einer Kategorie bekommen Vorrang, und bei einer breiten
         Anfrage aus einem einzigen Wort einen deutlichen. Wer nur "Leber" oder
         "Schilddruese" eingibt, will den Uebersichtsartikel, nicht einen
         Spezialfall wie "Leber bei Schilddruesenunterfunktion". */
      if (a.p) punkte += worte.length === 1 ? 10 : 6;

      // Frage-Antwort-Treffer: fuehrt direkt auf die Antwort.
      var besteFrage = null, fragePunkte = 0;
      a.fragen.forEach(function (f) {
        var p = 0;
        gruppen.forEach(function (g) {
          var b = 0;
          g.varianten.forEach(function (e) { var r = passt(e.w, f.tok); if (r) { var v = (r === 2 ? 8 : 4) * e.gew; if (v > b) b = v; } });
          p += b;
        });
        if (p > fragePunkte) { fragePunkte = p; besteFrage = f; }
      });
      if (fragePunkte > 0) { punkte += fragePunkte; getroffen++; }

      if (getroffen > 0 && punkte > 0) {
        treffer.push({ a: a, punkte: punkte, frage: fragePunkte >= 8 ? besteFrage : null });
      }
    });

    treffer.sort(function (x, y) { return y.punkte - x.punkte || x.a.t.localeCompare(y.a.t, 'de'); });
    return treffer.slice(0, MAX_TREFFER);
  }

  // Naechstliegendes Wort aus dem Titelwortschatz, fuer "Meintest du ..."
  function meinteDu(begriff, daten) {
    var tok = zerlege(begriff).filter(function (t) { return t.length >= 4; });
    if (!tok.length) return null;
    var bestes = null, bestD = 99;
    tok.forEach(function (t) {
      daten.vokabular.forEach(function (v) {
        // Hoechstens zwei Zeichen Unterschied. Bei drei kommen Vorschlaege
        // heraus, die nichts mit der Anfrage zu tun haben.
        var d = abstand(t, v, 2);
        if (d < bestD && d <= 2 && d > 0) { bestD = d; bestes = v; }
      });
    });
    if (!bestes) return null;
    // Das Originalwort eines Artikels zu dem Treffer finden, damit die
    // Anzeige lesbar bleibt und nicht normalisiert aussieht.
    for (var i = 0; i < daten.liste.length; i++) {
      var worte = String(daten.liste[i].t).split(/[\s,.;:()–-]+/);
      for (var j = 0; j < worte.length; j++) {
        if (normalisiere(worte[j]) === bestes || stamm(normalisiere(worte[j])) === bestes) return worte[j];
      }
    }
    return null;
  }

  function kategorieVorschlag(begriff) {
    var n = normalisiere(begriff);
    if (alltagIndex[n]) return katNachName[normalisiere(alltagIndex[n])] || null;
    var tok = n.split(' ');
    for (var i = 0; i < tok.length; i++) {
      if (alltagIndex[tok[i]]) return katNachName[normalisiere(alltagIndex[tok[i]])] || null;
      var st = stamm(tok[i]);
      if (alltagIndex[st]) return katNachName[normalisiere(alltagIndex[st])] || null;
    }
    // Tippfehler auch hier verzeihen
    var schluessel = Object.keys(alltagIndex);
    for (var t = 0; t < tok.length; t++) {
      if (tok[t].length < 5) continue;
      for (var s = 0; s < schluessel.length; s++) {
        if (abstand(tok[t], schluessel[s], 1) <= 1) return katNachName[normalisiere(alltagIndex[schluessel[s]])] || null;
      }
    }
    return null;
  }

  /* ── 4 Darstellung ─────────────────────────────────────────────────── */
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* Hervorheben braucht eine Normalisierung, die Zeichen fuer Zeichen
     arbeitet, sonst passen Original und normalisierte Fassung nicht mehr
     aufeinander. Deshalb hier nur Kleinschreibung, Umlaute und ss. */
  function normZeichen(c) {
    var x = c.toLowerCase();
    if (x === 'ß') return 'ss';
    if (x === 'ä') return 'a';
    if (x === 'ö') return 'o';
    if (x === 'ü') return 'u';
    if (x === 'é' || x === 'è' || x === 'ê') return 'e';
    if (x === 'á' || x === 'à' || x === 'â') return 'a';
    return /[a-z0-9]/.test(x) ? x : ' ';
  }
  function normLeicht(s) {
    var out = '';
    for (var i = 0; i < s.length; i++) out += normZeichen(s[i]);
    return out;
  }

  // Suchbegriff im Text hervorheben. Arbeitet auf dem Originaltext, damit
  // Umlaute und Schreibweise erhalten bleiben.
  function hebeHervor(text, begriff) {
    var roh = String(text || '');
    var worte = normLeicht(begriff).split(' ').filter(function (w) { return w.length >= 2; });
    if (!worte.length) return esc(roh);
    var stellen = [];
    var nWort = '', karte = [];
    for (var i = 0; i < roh.length; i++) {
      var n = normZeichen(roh[i]);
      for (var c = 0; c < n.length; c++) { nWort += n[c]; karte.push(i); }
    }
    worte.forEach(function (w) {
      var von = 0, p;
      while ((p = nWort.indexOf(w, von)) >= 0) {
        var a = karte[p], b = karte[Math.min(p + w.length - 1, karte.length - 1)];
        if (a != null && b != null) stellen.push([a, b + 1]);
        von = p + w.length;
      }
    });
    if (!stellen.length) return esc(roh);
    stellen.sort(function (x, y) { return x[0] - y[0]; });
    var zusammen = [stellen[0]];
    for (var s = 1; s < stellen.length; s++) {
      var letzte = zusammen[zusammen.length - 1];
      if (stellen[s][0] <= letzte[1]) letzte[1] = Math.max(letzte[1], stellen[s][1]);
      else zusammen.push(stellen[s]);
    }
    var out = '', pos = 0;
    zusammen.forEach(function (r) {
      out += esc(roh.slice(pos, r[0])) + '<mark>' + esc(roh.slice(r[0], r[1])) + '</mark>';
      pos = r[1];
    });
    return out + esc(roh.slice(pos));
  }

  function trefferHtml(t, begriff, position) {
    var a = t.a;
    var k = katVon(a.k);
    var ziel = artUrl(a.h);
    var zweite = a.a;
    if (t.frage) {
      ziel += '#frage-' + ankerId(t.frage.frage);
      zweite = t.frage.frage;
    }
    return '<li>' +
      '<a class="ws-treffer" href="' + esc(ziel) + '" data-ws-klick' +
      ' data-pos="' + position + '" data-ziel="' + esc(a.h) + '">' +
      (k ? '<span class="ws-treffer-kat">' + esc(k.name) + '</span>' : '') +
      '<span class="ws-treffer-titel">' + hebeHervor(a.t, begriff) +
      (a.p ? '<span class="ws-marke">Hauptartikel</span>' : '') + '</span>' +
      '<span class="ws-treffer-aus' + (t.frage ? ' ws-frage' : '') + '">' +
      (t.frage ? 'Frage: ' : '') + hebeHervor(zweite, begriff) + '</span>' +
      '</a></li>';
  }

  // Muss zeichengleich zur Anker-Vergabe auf der Artikelseite sein.
  function ankerId(s) {
    return String(s).toLowerCase()
      .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60);
  }

  /* Gruender-Stellungnahme (Vorgabe Lorenz, 22.10.2026).
     Im Wissensbereich nie. Dort liefert der Server die Daten gar nicht erst
     mit, sonder_artikel ist leer, es gibt also auch nichts zu verbergen.
     Ausserhalb nur, wenn die Eingabe einen der Begriffe enthaelt, und nie als
     Vorschlag bei einer allgemeinen Suche. */
  function sonderTreffer(begriff) {
    if (konfig.wissensseite) return null;
    if (!konfig.sonder_artikel || !konfig.sonder_artikel.length) return null;
    var n = normalisiere(begriff);
    if (!n) return null;
    var passt = (konfig.sonder_begriffe || []).some(function (b) {
      var nb = normalisiere(b);
      return nb.length >= 4 && n.indexOf(nb) >= 0;
    });
    return passt ? konfig.sonder_artikel : null;
  }

  function sonderHtml(artikel, begriff, startPosition) {
    var titel = konfig.sonder_titel || 'Aktuelles';
    var out = '<section class="ws-gruppe-ergebnis"><h3>' + esc(titel) + '</h3><ul class="ws-liste">';
    artikel.forEach(function (a, i) {
      out += '<li><a class="ws-treffer" href="' + esc(a.u) + '" data-ws-klick' +
        ' data-pos="' + (startPosition + i) + '" data-ziel="' + esc(a.h) + '">' +
        '<span class="ws-treffer-kat">' + esc(titel) + '</span>' +
        '<span class="ws-treffer-titel">' + hebeHervor(a.t, begriff) + '</span>' +
        '<span class="ws-treffer-aus">' + hebeHervor(a.a, begriff) + '</span></a></li>';
    });
    return out + '</ul></section>';
  }

  function felderHtml() {
    var gruppen = [];
    konfig.kategorien.forEach(function (k) { if (gruppen.indexOf(k.obergruppe) < 0) gruppen.push(k.obergruppe); });
    var h = '<div class="ws-felder">';
    gruppen.forEach(function (g) {
      var erste = null;
      konfig.kategorien.forEach(function (k) { if (!erste && k.obergruppe === g) erste = k; });
      if (erste) {
        h += '<a class="ws-feld-kat ws-feld-gruppe" href="' + esc(katUrl(erste)) +
          '" data-ws-vorschlag="obergruppe" data-ziel="' + esc(g) + '">' + esc(g) + '</a>';
      }
    });
    konfig.kategorien.forEach(function (k) {
      h += '<a class="ws-feld-kat" href="' + esc(katUrl(k)) +
        '" data-ws-vorschlag="kategorie" data-ziel="' + esc(k.name) + '">' + esc(k.name) + '</a>';
    });
    return h + '</div>';
  }

  function einstiegHtml(daten) {
    var karten = [];
    (konfig.einstieg || []).forEach(function (h) {
      var handle = String(h).trim();
      if (!handle) return;
      for (var i = 0; i < daten.liste.length; i++) {
        if (daten.liste[i].h === handle) { karten.push(daten.liste[i]); break; }
      }
    });
    if (!karten.length) return '';
    var out = '<h2 class="ws-titel">Zum Einstieg</h2><ul class="ws-liste">';
    karten.forEach(function (a, i) {
      var k = katVon(a.k);
      out += '<li><a class="ws-treffer" href="' + esc(artUrl(a.h)) +
        '" data-ws-vorschlag="einstieg" data-ziel="' + esc(a.h) + '" data-pos="' + (i + 1) + '">' +
        (k ? '<span class="ws-treffer-kat">' + esc(k.name) + '</span>' : '') +
        '<span class="ws-treffer-titel">' + esc(a.t) + '</span>' +
        '<span class="ws-treffer-aus">' + esc(a.a) + '</span></a></li>';
    });
    return out + '</ul>';
  }

  /* ── 5 Bedienung ─────────────────────────────────────────────────── */
  var ebene = document.getElementById('WissenSuche');
  if (!ebene) return;
  var feld = ebene.querySelector('[data-ws-feld]');
  var box = ebene.querySelector('[data-ws-ergebnisse]');
  var status = ebene.querySelector('[data-ws-status]');
  var leeren = ebene.querySelector('[data-ws-leeren]');
  var vorherFokus = null;
  var aktuell = '';
  var letzteAnzahl = 0;

  function sage(text) { if (status) status.textContent = text; }

  function zeigeStart() {
    aktuell = '';
    box.innerHTML = '<p class="ws-hinweis">Einen Moment, die Artikel werden geladen.</p>';
    ladeIndex().then(function (daten) {
      box.innerHTML = einstiegHtml(daten) +
        '<h2 class="ws-titel">Nach Thema stöbern</h2>' + felderHtml();
    }).catch(function () {
      box.innerHTML = '<p class="ws-hinweis">Die Artikelliste liess sich nicht laden. ' +
        'Du kannst trotzdem nach Thema stöbern.</p>' +
        '<h2 class="ws-titel">Nach Thema stöbern</h2>' + felderHtml();
    });
  }

  function zeigeTreffer(begriff) {
    ladeIndex().then(function (daten) {
      if (feld.value.trim() !== begriff) return;
      var treffer = suche(begriff, daten);
      letzteAnzahl = treffer.length;

      if (!treffer.length) {
        var vorschlag = meinteDu(begriff, daten);
        var kat = kategorieVorschlag(begriff);
        var h = '<h2 class="ws-titel">Dazu haben wir keinen Artikel gefunden</h2>';
        if (vorschlag) {
          h += '<p class="ws-hinweis">Meintest du <a href="#" data-ws-meinte="' + esc(vorschlag) +
            '"><strong>' + esc(vorschlag) + '</strong></a>?</p>';
        }
        if (kat) {
          h += '<p class="ws-hinweis">Passend dazu ist die Kategorie <a href="' + esc(katUrl(kat)) +
            '" data-ws-vorschlag="kategorie" data-ziel="' + esc(kat.name) + '"><strong>' +
            esc(kat.name) + '</strong></a>.</p>';
        }
        var sonderLeer = sonderTreffer(begriff);
        if (sonderLeer) h += sonderHtml(sonderLeer, begriff, 1);
        h += einstiegHtml(daten) + '<h2 class="ws-titel">Nach Thema stöbern</h2>' + felderHtml();
        box.innerHTML = h;
        sage('Keine Treffer für ' + begriff);
        return;
      }

      // Nach Kategorie gruppieren, Reihenfolge wie im Menue.
      var nachKat = {};
      treffer.forEach(function (t) {
        var k = katVon(t.a.k);
        var name = k ? k.name : 'Weitere Artikel';
        (nachKat[name] = nachKat[name] || []).push(t);
      });
      /* Gruppen nach ihrem besten Treffer ordnen, nicht nach der
         Menuereihenfolge. Sonst steht bei "leberwerte" die Gruppe Hashimoto
         oben, nur weil sie im Menue vor Leber kommt, und der Hauptartikel
         "Leberwerte verstehen" rutscht nach unten. */
      var reihenfolge = Object.keys(nachKat).sort(function (a, b) {
        return nachKat[b][0].punkte - nachKat[a][0].punkte;
      });

      var pos = 0, out = '';
      reihenfolge.forEach(function (name) {
        var g = nachKat[name];
        if (!g || !g.length) return;
        out += '<section class="ws-gruppe-ergebnis"><h3>' + esc(name) + '</h3><ul class="ws-liste">';
        g.forEach(function (t) { pos++; out += trefferHtml(t, begriff, pos); });
        out += '</ul></section>';
      });
      var sonder = sonderTreffer(begriff);
      if (sonder) out += sonderHtml(sonder, begriff, pos + 1);
      box.innerHTML = out;
      sage(treffer.length === 1 ? 'Ein Treffer' : treffer.length + ' Treffer');
    }).catch(function () {
      box.innerHTML = '<p class="ws-hinweis">Die Suche ist gerade nicht erreichbar. ' +
        'Du kannst nach Thema stöbern.</p><h2 class="ws-titel">Nach Thema stöbern</h2>' + felderHtml();
    });
  }

  var tippTimer = null;
  function beiEingabe() {
    var wert = feld.value.trim();
    leeren.toggleAttribute('data-an', wert.length > 0);
    if (wert === aktuell) return;
    aktuell = wert;
    if (wert.length < MINDESTLAENGE) { zeigeStart(); planeZaehlung(''); return; }
    zeigeTreffer(wert);
    planeZaehlung(wert);
  }

  function oeffne(startwert) {
    vorherFokus = document.activeElement;
    ebene.setAttribute('data-offen', '');
    document.body.classList.add('ws-fixiert');
    feld.value = startwert || '';
    leeren.toggleAttribute('data-an', !!(startwert && startwert.length));
    if (startwert && startwert.length >= MINDESTLAENGE) { aktuell = ''; beiEingabe(); } else { zeigeStart(); }
    setTimeout(function () { feld.focus(); }, 30);
  }

  function schliesse() {
    sendeJetzt();
    ebene.removeAttribute('data-offen');
    document.body.classList.remove('ws-fixiert');
    if (vorherFokus && vorherFokus.focus) vorherFokus.focus();
  }

  ebene.addEventListener('click', function (e) {
    if (e.target.closest('[data-ws-schliessen]')) { e.preventDefault(); schliesse(); return; }
    if (e.target.closest('[data-ws-leeren]')) {
      e.preventDefault(); feld.value = ''; beiEingabe(); feld.focus(); return;
    }
    var m = e.target.closest('[data-ws-meinte]');
    if (m) { e.preventDefault(); feld.value = m.getAttribute('data-ws-meinte'); beiEingabe(); feld.focus(); return; }
    var kl = e.target.closest('[data-ws-klick]');
    if (kl) {
      sendeJetzt();
      zaehleTrefferKlick(feld.value.trim(), kl.getAttribute('data-ziel'), kl.getAttribute('data-pos'));
      return;
    }
    var vs = e.target.closest('[data-ws-vorschlag]');
    if (vs) { zaehleVorschlag(vs.getAttribute('data-ws-vorschlag'), vs.getAttribute('data-ziel'), vs.getAttribute('data-pos')); }
  });

  feld.addEventListener('input', beiEingabe);
  feld.addEventListener('blur', sendeJetzt);
  feld.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { e.preventDefault(); schliesse(); return; }
    if (e.key === 'Enter') {
      e.preventDefault();
      sendeJetzt();
      var b = feld.value.trim();
      try {
        if (b) history.replaceState(null, '', location.pathname + '?q=' + encodeURIComponent(b));
      } catch (err) {}
      return;
    }
    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
    var ziele = Array.prototype.slice.call(box.querySelectorAll('.ws-treffer'));
    if (!ziele.length) return;
    e.preventDefault();
    var i = ziele.indexOf(document.activeElement);
    i = e.key === 'ArrowDown' ? Math.min(i + 1, ziele.length - 1) : Math.max(i - 1, 0);
    ziele.forEach(function (z) { z.setAttribute('aria-selected', 'false'); });
    ziele[i].setAttribute('aria-selected', 'true');
    ziele[i].focus();
  });

  document.addEventListener('keydown', function (e) {
    if (!ebene.hasAttribute('data-offen')) return;
    if (e.key !== 'Tab') return;
    var greif = ebene.querySelectorAll('input, button, a[href]');
    if (!greif.length) return;
    var erst = greif[0], letzt = greif[greif.length - 1];
    if (e.shiftKey && document.activeElement === erst) { e.preventDefault(); letzt.focus(); }
    else if (!e.shiftKey && document.activeElement === letzt) { e.preventDefault(); erst.focus(); }
  });

  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-ws-oeffnen]');
    if (!o) return;
    e.preventDefault();
    oeffne(o.getAttribute('data-ws-start') || '');
  });

  // Adresse mit ?q=... oder #q=... oeffnet die Suche direkt.
  (function () {
    var p = new URLSearchParams(location.search).get('q');
    if (!p && location.hash.indexOf('q=') === 1) {
      try { p = decodeURIComponent(location.hash.slice(3)); } catch (e) {}
    }
    if (p && p.trim()) {
      // Suchergebnisse gehoeren nicht in den Index.
      if (!document.querySelector('meta[name="robots"]')) {
        var m = document.createElement('meta');
        m.name = 'robots'; m.content = 'noindex, follow';
        document.head.appendChild(m);
      }
      oeffne(p.trim());
    }
  })();

  // Auf den Wissensseiten den Index im Hintergrund vorladen.
  if (/\/blogs\/wissen/.test(location.pathname)) {
    var vorladen = function () { ladeIndex().catch(function () {}); };
    if ('requestIdleCallback' in window) requestIdleCallback(vorladen, { timeout: 4000 });
    else setTimeout(vorladen, 2500);
  }

  /* ── 6 Zaehlung ────────────────────────────────────────────────────
     Nur dataLayer.push, genau wie das bestehende Engagement-Skript. Es wird
     KEINE zweite gtag-config angelegt und kein Kauf-Tracking beruehrt.
     Am 01.06.2026 hat eine zweite Zaehlkonfiguration die Seitenaufrufe einer
     Domain unterdrueckt, deshalb hier bewusst nur dieser eine Weg.
     Die Zustimmung regelt wie bisher der Tag-Manager, nicht dieses Skript.
  */
  function schiebe(name, daten) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, daten));
    } catch (e) {}
  }

  // Begriffe saeubern: klein, getrimmt, nichts was nach E-Mail-Adresse oder
  // langer Ziffernfolge aussieht, nichts ueber 80 Zeichen.
  function saeubere(b) {
    var s = String(b || '').trim().replace(/\s+/g, ' ').toLowerCase();
    if (!s) return '';
    if (s.indexOf('@') >= 0) return '';
    if (/\d{7,}/.test(s.replace(/\D/g, ''))) return '';
    return s.slice(0, 80);
  }

  var offenerBegriff = '', sendeTimer = null, zuletztGesendet = '';

  function planeZaehlung(begriff) {
    offenerBegriff = begriff;
    if (sendeTimer) clearTimeout(sendeTimer);
    if (!begriff || begriff.length < MINDESTLAENGE) return;
    sendeTimer = setTimeout(sendeJetzt, SENDE_PAUSE);
  }

  /* Hier faellt die Entscheidung, was gezaehlt wird. Beide Ereignisse gehen
     erst nach der Eingabepause raus, beim Verlassen des Feldes, beim Klick
     oder bei Enter. Nicht bei jedem Tastendruck, sonst zaehlt "schilddruese"
     als zwoelf Suchen und Lorenz liest zwoelf Bruchstuecke. */
  function sendeJetzt() {
    if (sendeTimer) { clearTimeout(sendeTimer); sendeTimer = null; }
    var b = saeubere(offenerBegriff);
    if (!b || b === zuletztGesendet) return;
    zuletztGesendet = b;
    schiebe('view_search_results', { search_term: b, search_source: 'wissen', results_count: letzteAnzahl });
    if (letzteAnzahl === 0) {
      schiebe('search_no_results', { search_term: b, search_source: 'wissen' });
    }
  }

  function zaehleTrefferKlick(begriff, ziel, pos) {
    var b = saeubere(begriff);
    schiebe('search_result_click', {
      search_term: b, search_source: 'wissen',
      search_result_handle: ziel || '', search_result_position: Number(pos) || 0
    });
  }

  function zaehleVorschlag(art, ziel, pos) {
    schiebe('search_suggestion_click', {
      search_source: 'wissen', suggestion_type: art || '',
      suggestion_target: ziel || '', suggestion_position: Number(pos) || 0
    });
  }

  /* Artikelzahl in den Kategorie-Kacheln nachtragen, sobald der Index da ist.
     Serverseitig geht das nicht: Shopify kennt keine Artikelzahl je Schlagwort,
     und eine fest eingetippte Zahl waere ab dem naechsten Artikel falsch. */
  (function () {
    var felder = document.querySelectorAll('[data-wissen-zahl]');
    if (!felder.length) return;
    ladeIndex().then(function (daten) {
      var zahl = {};
      daten.liste.forEach(function (a) { if (a.k) zahl[a.k] = (zahl[a.k] || 0) + 1; });
      felder.forEach(function (el) {
        var n = zahl[el.getAttribute('data-wissen-zahl')] || 0;
        el.textContent = n === 1 ? '1 Artikel' : n + ' Artikel';
      });
    }).catch(function () {});
  })();

  /* Nur fuer die Pruefung auf dem Rechner: wenn window.__wsTest gesetzt ist,
     werden die reinen Rechenfunktionen herausgegeben. Im Shop ist __wsTest
     nie gesetzt, dieser Block laeuft dort also nicht. */
  if (typeof window !== 'undefined' && window.__wsTest) {
    window.__wsTest({
      suche: suche, bereiteVor: bereiteVor, normalisiere: normalisiere,
      zerlege: zerlege, meinteDu: meinteDu, kategorieVorschlag: kategorieVorschlag,
      katVon: katVon, sonderTreffer: sonderTreffer, konfig: konfig
    });
  }
})();
